module.exports = __webpack_public_path__ + "static/media/Mobile_storytelling_e_ux.47ce1630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Storytelling/Mobile_storytelling_e_ux.png
// module id = 196
// module chunks = 0